import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sdc-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css']
})
export class SalesComponent {
  constructor(private router: Router) {}

  navigateTo(route: string): void {
    this.router.navigate(['/sales', route]);
  }
}
